export const integrationQueryKeys = {
    read: (scenarioId: string) => ["integration", "read", scenarioId],
} as const;
